const MAIN_BUNDLE_PATTERN = /\/static\/js\/main\.[^/]+\.js$/;
const OUTDATED_APP_REFRESHED_KEY = "app:update:outdatedAppRefreshed";

const normalizeAssetPath = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  try {
    const url = new URL(value, window.location.origin);
    return `${url.pathname}${url.search}`;
  } catch (error) {
    return value;
  }
};

export const getCurrentMainBundlePath = () => {
  const scripts = Array.from(document.querySelectorAll("script[src]"));
  const matchingScript = scripts.find((scriptTag) =>
    MAIN_BUNDLE_PATTERN.test(scriptTag.getAttribute("src") || "")
  );

  return normalizeAssetPath(matchingScript?.getAttribute("src") || null);
};

export const fetchLatestMainBundlePath = async () => {
  const manifestUrl = `${process.env.PUBLIC_URL || ""}/asset-manifest.json?t=${Date.now()}`;
  const response = await fetch(manifestUrl, {
    cache: "no-store",
    headers: { "cache-control": "no-cache" },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch asset manifest: ${response.status}`);
  }

  const manifest = await response.json();
  return normalizeAssetPath(manifest?.files?.["main.js"] || null);
};

export const buildReloadUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.set("app_updated_at", String(Date.now()));
  return url.toString();
};

const isOutdatedAppAssetError = (error) => {
  const message = String(error?.message || "");
  const name = String(error?.name || "");
  return (
    name.includes("ChunkLoadError") ||
    message.includes("ChunkLoadError") ||
    message.includes("Loading chunk")
  );
};

export const registerOutdatedAppAutoRefresh = () => {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  const triggerAutoRefresh = () => {
    if (sessionStorage.getItem(OUTDATED_APP_REFRESHED_KEY) === "true") {
      return;
    }

    sessionStorage.setItem(OUTDATED_APP_REFRESHED_KEY, "true");
    window.location.replace(buildReloadUrl());
  };

  window.addEventListener("error", (event) => {
    if (isOutdatedAppAssetError(event?.error || event)) {
      triggerAutoRefresh();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isOutdatedAppAssetError(event?.reason)) {
      triggerAutoRefresh();
    }
  });
};
